export class Settings {
    agentSessionDate:string;
    code: string;
    description: string;
    url: string;
    profileName: string;
    userId: string;
    password: string;
    dataSetNo: string;
    types: string;
    locationCode: string;
    showQuantityOfAllLocations: boolean;
    customerKey: string;
    agentSessionId: string;
    gatewaySessionId: string;
    remoteServer: string;
    datasetTenantId: string;
    uiDefKey: string;
    agentEmail: string;
    agentPassword: string;
    appName: string = 'AgrisSales';
    numberOfCustomersInSearchResult: number;
    numberOfItemsInSearchResult: number;
    agentUsername: string;
    agentEncryptedPassword: string;
    startNameIdType: string = '';
    endNameIdType: string = '';
    quotesExpiryDays: number = 7;
    ccEmail:string = '';
    disableQuotesExpiry: boolean = true;
    LocationCodeDv: string = '';
}

